// src/components/Header.jsx
import React from 'react';
import '../styles/Header.css';
import aioticslogo from '../assets/aiotics.png'; // put your logo inside src/assets

const Header = ({ page }) => {
  const getTitle = () => {
    switch (page) {
      case 'home':
        return 'Pharma Bioreactor Unit';
      case 'manufacturing':
        return 'Manufacturing Plant Control Unit';
      case 'powerplant':
        return 'Power Plant Control Center';
      case 'dashboard':
        return 'Central Dashboard';
      case 'about':
        return 'About Us';
      case 'login':
        return 'User Login';
      default:
        return 'User Profile';
    }
  };

  return (
    <header className="header">
      {/* Left Logo */}
      <div className="logo">
        <img src={aioticslogo} alt="Left Logo" className="logo-image" />
      </div>

      {/* Dynamic Heading */}
      <h1 className="heading">{getTitle()}</h1>

      {/* Right Logo */}
      <div className="logo right-logo">
        <img src="aiotics_logo.svg" alt="Right Logo" className=" partner-logo" />
      </div>
    </header>
  );
};

export default Header;
